export default __webpack_public_path__ + "navigation-guides-turn-by-turn-ui-speed-limit-1200-d0aaeb86798888d88e49cfde9934f932.webp";